import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {KennethMustDie} from "../KennethMustDie";
import {gsap} from "gsap";
import {IFeatureInfo} from "../server/IKMDData";
import {KMDSymbol} from "../reels/KMDSymbol";
import {SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {KMDSound} from "../sound/KMDSound";

export class KMDXWaysRevealRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return (KennethMustDie.model.xWaysMainReels.length > 0 || KennethMustDie.model.xWaysSpecialRow.length > 0);
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
                onComplete: () => {
                    controller.finish();
                }
            }),
            mysterySymbol: string = KennethMustDie.model.gameData.mysterySymbolRevealed,
            mysterySymbolSize: number = KennethMustDie.model.gameData.mysterySymbolSize,
            xWaysMainReels: IFeatureInfo[] = KennethMustDie.model.xWaysMainReels,
            xWaysSpecialRow: IFeatureInfo[] = KennethMustDie.model.xWaysSpecialRow,
            additionalYReveal: number[] = [75, 0, -75],
            additionalYXWay: number[] = [150, 75, 0],
            multipliers: number[][] = KennethMustDie.model.gameData.multiplier;

        tl.add(() => {
            controller.setSkipCallback(() => {
                this.onSkip(tl);
            });

            // #240
            KennethMustDie.soundPlayer.playSound(KMDSound.X_WAYS_REVEAL);
        });

        xWaysMainReels.forEach((xWay: IFeatureInfo) => {
            const allSymbols: SimpleReelModelSymbolData[] = KennethMustDie.reelView.reelModels[xWay.originReelId].stopSymbols;

            for (let i: number = 0; i < allSymbols.length; i++) {
                if (allSymbols[i].reelPosition === xWay.originSymId) {
                    const xWaysSymbol: KMDSymbol = (allSymbols[i].positionable as KMDSymbol);

                    tl.add([
                        KennethMustDie.xWaysReveal.playRevealAnimation(xWaysSymbol.x + xWaysSymbol.parent.x + xWaysSymbol.parent.parent.x, xWaysSymbol.y + xWaysSymbol.parent.y + xWaysSymbol.parent.parent.y + additionalYReveal[xWay.originSymId], xWay.originReelId),
                        xWaysSymbol.revealXWays(mysterySymbol, additionalYXWay[xWay.originSymId], (multipliers[(xWay.originReelId)][i]))
                    ], 0);

                    break;
                }
            }
        });

        xWaysSpecialRow.forEach((xWay: IFeatureInfo) => {
            const xWaysSymbol: KMDSymbol = (KennethMustDie.specialReelView.reel.getStopSymbolAt(xWay.originSymId).positionable as KMDSymbol);

            tl.add([
                KennethMustDie.xWaysReveal.playRevealAnimation(xWaysSymbol.x + xWaysSymbol.parent.x + xWaysSymbol.parent.parent.x, xWaysSymbol.y + xWaysSymbol.parent.y + xWaysSymbol.parent.parent.y - 75, xWay.originReelId),
                xWaysSymbol.revealXWays(mysterySymbol, 0, (multipliers[(xWay.originSymId + 1)][3]))
            ], 0);
        });

        tl.add(() => {
            xWaysMainReels.forEach((xWay: IFeatureInfo) => {
                KennethMustDie.SYMBOLS_NUM_PER_REEL[xWay.originReelId] += (Math.max(multipliers[xWay.originReelId][xWay.originSymId], 1) * (mysterySymbolSize - 1)); // subtracting 1, as 1 symbol is already counted in reel stop/xHole.
            });

            xWaysSpecialRow.forEach((xWay: IFeatureInfo) => {
                KennethMustDie.SYMBOLS_NUM_PER_REEL[xWay.originReelId] += (Math.max(multipliers[xWay.originReelId][3], 1) * (mysterySymbolSize - 1)); // subtracting 1, as 1 symbol is already counted in reel stop/xHole.
            });

            KennethMustDie.possibleWays.updateWays();
        });

        tl.to(this, {
            duration: 0.1
        });
    }

    private onSkip(tl: gsap.core.Timeline): void {
        tl.totalProgress(1);
    }
}